import { Form, FormRenderProps } from 'react-final-form';
import { FormApi } from 'final-form';
import arrayMutators from 'final-form-arrays';

import { Box } from '@occc-app/design-system';
import { LoadingOverlay } from '@occc/ui-design-system';
import { Flow_Types } from '@occc-app/offerHelpers/types';
import { OfferForm } from '@occc-app/offerHelpers/components/OfferForm';

import { ConfigureFormContent } from './ConfigureFormContent';
import { validateConfigureForm } from './utils';

import { ConfigureFormInitialValues, ConfigureFormValues, AWARD_TYPES } from '../../types';

type ConfigureFormProps = {
  onSubmit: (
    values: ConfigureFormValues,
    form: FormApi<ConfigureFormValues, ConfigureFormInitialValues>,
  ) => Promise<void> | void;
  onCancelClick: (hasUnsavedChanges?: boolean) => void;
  initialValues: ConfigureFormInitialValues;
  loading: boolean;
};

export const AwardConfigureForm = ({
  onSubmit,
  onCancelClick,
  initialValues,
  loading,
}: ConfigureFormProps) => {
  const render: FormRenderProps<ConfigureFormValues, ConfigureFormInitialValues>['render'] = ({
    handleSubmit,
    values,
    form,
    submitting,
    dirty,
  }) => {
    const setAwardType = (type: AWARD_TYPES) => form.change('awardType', type);

    return (
      <OfferForm dirty={!submitting && dirty} handleSubmit={handleSubmit}>
        <Box position='relative'>
          <ConfigureFormContent
            values={values}
            setAwardType={setAwardType}
            isReadOnlyRole={false}
            currentFlowType={Flow_Types.Configure}
            handleCancel={onCancelClick}
            submitting={submitting}
            dirty={dirty}
          />
          {loading && <LoadingOverlay rounded />}
        </Box>
      </OfferForm>
    );
  };

  return (
    <Form<ConfigureFormValues, ConfigureFormInitialValues>
      onSubmit={onSubmit}
      render={render}
      initialValues={initialValues}
      validate={validateConfigureForm}
      keepDirtyOnReinitialize
      mutators={{ ...arrayMutators }}
    />
  );
};
